import React from 'react';
import { Button } from 'react-aria-components';
import { SearchFacet } from '../../../types/search';
import { useDateFilter } from '../contexts/PortalDateFilterProvider';
import eventBus, { CUSTOM_EVENTS } from '../../utils/EventBus';

interface PortalSelectDateButtonProps {
  readonly setDatePickerOpen: (isOpen: boolean) => void;
  readonly setFiltersHeading: (heading: string) => void;
  readonly currentDateFacet: SearchFacet;
  readonly pendingFilterState?: Record<string, string | string[]> | null;
  readonly appliedFilters?: unknown[];
  readonly handleFilterChange?: (filter: string, values: string | string[]) => void;
  readonly children: React.ReactNode;
}

export default function PortalSelectDateButton({
  setDatePickerOpen,
  setFiltersHeading,
  currentDateFacet,
  pendingFilterState: _pendingFilterState,
  appliedFilters: _appliedFilters,
  handleFilterChange,
  children,
}: PortalSelectDateButtonProps) {
  const { selectedValue } = useDateFilter(currentDateFacet?.key);
  const handleSelectDate = () => {
    if (!currentDateFacet) {
      setDatePickerOpen(false);
      return;
    }

    if (handleFilterChange) {
      const [startDate, endDate] = selectedValue.split(',');
      handleFilterChange(currentDateFacet.key, endDate ? [startDate, endDate] : selectedValue);

      eventBus.emit(CUSTOM_EVENTS.PORTAL_DATEPICKER_MODE_UPDATE, {
        mode: currentDateFacet,
        selectedValue: endDate ? [startDate, endDate] : selectedValue,
      });
    }

    setDatePickerOpen(false);
    setFiltersHeading('Filters');
  };

  return (
    <Button className="cta cta--primary cta--small" onPress={handleSelectDate}>
      {children}
    </Button>
  );
}
